import { UserRoundX } from 'lucide-react';
import LangEnum from '../../../lang/LangEnum';
import { CONNECTION_STATUS_CHIP_CONFIG } from '../../customer/customerStatus/connectionStatusChip.constants';
import { CUSTOMER_STATUS_CHIP_CONFIG } from '../../customer/customerStatus/customerStatusChip.constants';
import { INTEGRATION_STATUS_CHIP_CONFIG } from '../../integrations/components/integrationStatusChip.constants';
import type { InviteBrandStatus } from '../../my-network/myNetwork.types';
import { ORDER_STATUS_CHIP_CONFIG } from '../../orders/list/components/orderStatusChip.constants';
import { TARGET_STATUS_CHIP_CONFIG } from '../../target/list/targetStatusChip.constants';
import type {
  ActivityFeedStatusChip,
  ActivityFeedStatusChipByStatus,
} from './activityFeedPhrase.types';

export const CUSTOMER_CHIP_BY_STATUS: ActivityFeedStatusChipByStatus = CUSTOMER_STATUS_CHIP_CONFIG;

export const ORDER_CHIP_BY_STATUS: ActivityFeedStatusChipByStatus = ORDER_STATUS_CHIP_CONFIG;

export const INTEGRATION_CHIP_BY_STATUS: ActivityFeedStatusChipByStatus =
  INTEGRATION_STATUS_CHIP_CONFIG;

export const TARGET_CHIP_BY_STATUS: ActivityFeedStatusChipByStatus = TARGET_STATUS_CHIP_CONFIG;

export const CONNECTION_CHIP_BY_BRAND_STATUS: Record<
  InviteBrandStatus,
  ActivityFeedStatusChip | null
> = {
  SOLICITADO: CONNECTION_STATUS_CHIP_CONFIG.CONVITE_ENVIADO,
  AGUARDANDO: CONNECTION_STATUS_CHIP_CONFIG.CONVITE_RECEBIDO,
  CONECTADO: CONNECTION_STATUS_CHIP_CONFIG.CONECTADO,
  IGNORADO: { label: LangEnum.GLOBAL_IGNORED, icon: UserRoundX, color: 'neutral' },
  SUGERIDO_VENDEDOR: null,
  RECUSADO_ADMIN: null,
};

export const findActivityFeedStatusChip = (chips: ActivityFeedStatusChipByStatus, status: string) =>
  chips[status.toUpperCase()] ?? null;
